// assets/js/vendor.js
import utilitiesAll from './utilities/utilitiesAll';
// リロード後位置を最上部に戻す
history.scrollRestoration = 'manual';
// 初期化
document.addEventListener('DOMContentLoaded', async () => {
  try {
    await utilitiesAll();
  } catch (error) {
    console.error("Error initializing utilities:", error);
  }
});
